const cacheImages = async (sources: string[]) => {
  const promises = await sources.map((source) => {
    return new Promise((resolve, reject) => {
      const img = new Image()
      img.src = source
      img.onload = resolve
      img.onerror = reject
    })
  })

  await Promise.allSettled(promises)
}

export default cacheImages
